import { I18n } from '@calendly/i18n';
import { AddMiniIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { addLocation } from './actions';
import { sortedActiveLocationsSelector } from './selectors';
import { useStateValue, useDispatchValue } from './state_provider';
const MAX_LOCATIONS = 10;
const questionCss = "q180y26x";
const Question = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(questionCss, props.className)} />;
});
export const AddLocation = () => {
  const dispatch = useDispatchValue();
  const sortedLocations = sortedActiveLocationsSelector(useStateValue());
  const maxLocationsAdded = sortedLocations.length >= MAX_LOCATIONS;
  const hasUnsetLocation = sortedLocations.some(([_, location]) => !location.kind);
  const multipleLocationsAdded = sortedLocations.length > 1;
  const handleAddLocation = () => dispatch(addLocation());
  if (maxLocationsAdded || hasUnsetLocation) return null;
  return <>
      {!multipleLocationsAdded && <Question>
          {I18n.t('publisher.event_types.location.want_to_offer')}
          &nbsp;
        </Question>}
      <MinimalButton fontSize="medium" onClick={handleAddLocation}>
        {multipleLocationsAdded && <AddMiniIcon />}
        {I18n.t('publisher.event_types.location.add')}
      </MinimalButton>
    </>;
};

require("./add_location.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./add_location.js");